const pbs_locations = {
	description:
		"Beheer de beschikbare PBS locaties voor de klant. Met de schuifjes kan bepaald worden of een node beschikbaar is voor voor de klant om een gratis PBS en/of betaalde PBS aan te kunnen maken. Wanneer beide schuifjes uitgeschakeld zijn kan op die node geen nieuwe PBS'en door klanten aangemaakt worden. Als alle schuifjes van alle nodes zijn uitgeschakeld werkt de dienst niet omdat de klant dan geen land of locatie kan selecteren.",
	messages: {
		pbs_allow_free_updates: "Status voor gratis PBS'en succesvol gewijzigd op node.",
		pbs_allow_paid_updates: "Status voor betaalde PBS'en succesvol gewijzigd op node.",
	},
	node: {
		pbs_allow_free: {
			label: "Gratis PBS'en toestaan op node",
		},
		pbs_allow_paid: {
			label: "Betaalde PBS'en toestaan op node",
		},
		pbs_usage: {
			cant_fetch: "Niet beschikbaar",
			label: "PBS gebruik",
		},
	},
	title: "PBS locatie management",
};

export default pbs_locations;
